module.exports = __webpack_public_path__ + "img/aboutus.61eecd09.jpg";